import { Container, Typography, Card, CardContent } from '@mui/material';
import { useDashboardData } from './hooks/useDashboardData';
import FiltroPeriodo from './FiltroPeriodo';
import ResumenCards from './ResumenCards';
import GraficoResumen from './GraficoResumen';

export default function DashboardApp() {
  const d = useDashboardData();

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        📊 Dashboard del Negocio
      </Typography>

      <FiltroPeriodo
        mes={d.mes}
        setMes={d.setMes}
        anio={d.anio}
        setAnio={d.setAnio}
      />

      <ResumenCards
        ventas={d.totalVentas}
        compras={d.totalCompras}
        gastos={d.totalGastos}
        utilidad={d.utilidad}
      />

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Resumen del período
          </Typography>
          <GraficoResumen data={d.graficoData} />
        </CardContent>
      </Card>
    </Container>
  );
}
